export const athleteReviews = [
  {
    quote:
      "Ultrahuman's innovative training and coaching platform will help the athletes achieve their performance goals. Athletes will get data-backed interventions to improve their performance and recovery protocols.",
    name: 'Roojai Insurance Cycling Team',
    profile: 'Lorem ipsum dolor sit amet. 1',
  },
  {
    quote:
      'The Ultrahuman Ring is a great tool to better understand things like sleep quality and HRV which are important considerations when preparing your fueling needs.',
    name: 'Team UAE Emirates',
    profile: 'Lorem ipsum dolor sit amet. 2',
  },
  {
    quote:
      'This collaboration will assist us in optimizing our training and preparation so that we can continue to compete at the highest level.',
    name: 'UAE Team ADQ',
    profile: 'Lorem ipsum dolor sit amet. 3',
  },
];

export const healthcareWorkerReviews = [
  {
    quote:
      'The Ultrahuman Ring has taught me to care for myself as I do my patients – taking vitals regularly and adjusting care based on the data. I am not only healthier with this ring, but a better nurse.',
    name: 'Janet, RN',
    profile: 'Lorem ipsum dolor sit amet. 1',
  },
  {
    quote:
      'Looking at my sleep cycle has become one of the first things I do when I get up. It prepares me for what to expect from my performance and, if I’ve had a bad night, not to beat myself up.',
    name: 'Maribeth',
    profile: 'Lorem ipsum dolor sit amet. 2',
  },
  {
    quote:
      'The Ring AIR has been a game-changer in optimizing my sleep, recovery, and stress. It also helps me be more cognizant of my movement or lack thereof. The Ring has allowed me to make real-time adjustments, enhancing my overall well-being.',
    name: 'Dr. Kim, RN, BSN',
    profile: 'Lorem ipsum dolor sit amet. 3',
  },
];

export const carouselImagesAthletes = [
  {
    mobileSrc: 'Team_UAE_Emirates_latest.jpg',
    desktopSrc: 'Team_UAE_Emirates_latest.jpg',
    caption: 'Team UAE Emirates',
  },
  {
    mobileSrc: 'UAE_Team_ADQ_latest.jpg',
    desktopSrc: 'UAE_Team_ADQ_latest.jpg',
    caption: 'UAE Team ADQ',
  },
  {
    mobileSrc: 'Roojai_Insurance_Cycling_Team_latest.jpg',
    desktopSrc: 'Roojai_Insurance_Cycling_Team_latest.jpg',
    caption: 'Roojai Insurance Cycling Team',
  },
];

export const carouselImagesHealthCare = [
  {
    mobileSrc: 'Partnering_With_Hospital_Leaders.jpg',
    desktopSrc: 'Partnering_With_Hospital_Leaders.jpg',
    caption:
      'Partnered with hospital leaders to tackle burnout and promote recovery.',
  },
  {
    mobileSrc: 'Nursing_Welfare_latest.jpg',
    desktopSrc: 'Nursing_Welfare_latest.jpg ',
    caption:
      'Supports nursing welfare initiatives and educates through events.',
  },
  {
    mobileSrc: 'Jackson_Health_latest.jpg ',
    desktopSrc: 'Jackson_Health_latest.jpg ',
    caption: 'Collaborates with Jackson Health in Miami to reach 700+ nurses.',
  },
];
